import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const listItemStaticStyles = {
  fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall
};
const getListItemStyles = (theme) => ({
  ...listItemStaticStyles,
  color: theme.palette.text.primary
});
const MuiListItem = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...getListItemStyles(theme)
    })
  }
};
export {
  MuiListItem,
  getListItemStyles,
  listItemStaticStyles
};
//# sourceMappingURL=MuiListItem.js.map
